// Editor.js block tool for the restaurant-menu module's menu block. Stores only
// a display setting ({ columns: 1 | 2 | 3 }) — the menus themselves are pulled
// from the published site's build-time menu feed — so the editor shows a
// column-count picker with a static explanation, not a live preview.

const ICON =
  '<svg width="17" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3zm0 0v7"/></svg>';

const COLUMN_OPTIONS = [1, 2, 3];

export class MenuTool {
  static get toolbox() {
    return { title: "Menu", icon: ICON };
  }

  constructor({ data, block }) {
    this.block = block;
    this.data = {
      columns: COLUMN_OPTIONS.includes(data?.columns) ? data.columns : 2,
    };
  }

  render() {
    const root = document.createElement("div");
    root.className = "pgs-gallery-tool";

    const bar = document.createElement("div");
    bar.className = "pgs-gallery-tool__bar";
    const title = document.createElement("span");
    title.className = "pgs-gallery-tool__title";
    title.textContent = "Menu";

    const label = document.createElement("span");
    label.className = "pgs-gallery-tool__title";
    label.style.fontWeight = "400";
    label.style.color = "var(--muted-foreground, #6b7280)";
    label.textContent = "Columns";

    const toggle = document.createElement("div");
    toggle.className = "pgs-gallery-tool__toggle";
    const buttons = COLUMN_OPTIONS.map((value) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "pgs-gallery-tool__btn";
      button.textContent = String(value);
      button.setAttribute("aria-label", `${value} column${value > 1 ? "s" : ""}`);
      button.addEventListener("click", () => {
        this.data.columns = value;
        applyColumns();
        this.block?.dispatchChange?.();
      });
      toggle.appendChild(button);
      return { value, button };
    });
    const applyColumns = () => {
      for (const { value, button } of buttons) {
        button.classList.toggle("pgs-gallery-tool__btn--active", this.data.columns === value);
      }
    };
    applyColumns();

    bar.append(title, label, toggle);

    const note = document.createElement("div");
    note.className = "pgs-gallery-tool__preview";
    note.textContent =
      "Your menus show here — they update on the live site as soon as you publish. " +
      "Manage the dishes under Menu; the columns above set how the sections lay out on wide screens.";

    root.append(bar, note);
    return root;
  }

  save() {
    return { columns: this.data.columns };
  }
}
